import { LoadableAfterPaint } from '@confluence/loadable';

export const BannerSpacer = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BannerSpacer" */ '../src/BannerSpacer.tsx'))
			.BannerSpacer,
});
